module.exports = __webpack_public_path__ + "static/img/6.e6a8392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/6.png
// module id = Fqp1
// module chunks = 35